import React from "react";
import { List, Text, ListItem } from "@chakra-ui/react";

export const ProductList = ({ products, productSelectCallback }) => {
  return (
    <>
      <Text fontSize="lg" fontWeight="bold" textAlign="center" pb="2">
        Products
      </Text>
      <List width="100%">
        {products.length > 0 ? (
          products.map((product) => (
            <ListItem
              key={product.id}
              cursor="pointer"
              onClick={() => productSelectCallback(product.id)}
              _hover={{
                background: "rgba(27,110,194, 0.8)",
                color: "#fff",
                borderRadius: "4px",
              }}
            >
              <Text fontSize="md" borderTop="1px solid #eee" padding="2">
                {product.productName}
              </Text>
            </ListItem>
          ))
        ) : (
          <Text>No Products to show.</Text>
        )}
      </List>
    </>
  );
};
